import { BasketItem } from '../client/src';

export type CreateBasketItem = Pick<BasketItem, 'ticketID' | 'quantity'>;
